import { render } from "./Teams.vue?vue&type=template&id=fd56f144&ts=true"
import script from "./Teams.vue?vue&type=script&lang=ts"
export * from "./Teams.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/levelpro-feed-widget/levelpro-feed-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__